import { proxyException, PageResponse, ErrorMessageFromResponse } from '@/utils/communication'
import { FilterInvoiceSummary } from '@/utils/invoice'
import SelectCountry from '../select-country/select-country-tmpl'
import USStates from '@/static/states/us_states.json'
import _ from 'lodash'

export default {
  name: 'plan-upgrade-overview',
  inject: [
    '$utils',
    '$api'
  ],
  components: {
    SelectCountry
  },
  props: {
    billingDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    payment: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      model: {
        countryCode: '',
        countryName: '',
        state: ''
      },
      invoiceSummary: {},
      errorMessage: null,
      USStates
    }
  },
  watch: {
    billingDetails: {
      immediate: true,
      handler (newBillingDetails) {
        if (newBillingDetails) {
          this.setModelData(newBillingDetails)

          /**
           * Get Invoice summary by default if country code is not empty.
           */
          if (!_.isEmpty(this.model.countryCode)) {
            this.getInvoiceSummary()
          }
        }
      }
    }
  },
  computed: {
    showInvoice () {
      return !_.isEmpty(this.invoiceSummary)
    },
    showSelectState () {
      return this.model.countryCode === 'US'
    },
    filteredInvoiceSummary () {
      return FilterInvoiceSummary(this.invoiceSummary, true)
    }
  },
  methods: {
    setModelData (billingDetails) {
      this.model.countryCode = billingDetails?.countryCode ?? ''
      this.model.countryName = billingDetails?.country ?? ''
      this.model.state = billingDetails?.state ?? ''
    },
    handleCountryChange ($event) {
      // NOTE: always reset state on non-us country
      if ($event.countryCode !== 'US') {
        this.model.state = ''
      }

      if (!_.isEmpty($event.countryCode)) {
        this.model.countryCode = $event.countryCode
        this.model.countryName = $event.countryName

        if (!this.showSelectState) {
          this.getInvoiceSummary()
        }
      }
    },
    handleStateChange ($event) {
      if (!_.isEmpty(this.model.countryCode) && !_.isEmpty(this.model.state)) {
        this.getInvoiceSummary()
      }
    },
    // Backend request to pull invoice by country
    async loadInvoiceSummaryByCountry () {
      return await proxyException(() => this.$api.get(`${CONFIG.API_BASE_URL}/invoice/summary`, {
        params: {
          countryCode: this.model.countryCode
        }
      }))
    },
    async getInvoiceSummary () {
      this.errorMessage = null

      this.$utils.mainLoader(true)
      const { ok: response, error } = await this.loadInvoiceSummaryByCountry()
      this.$utils.mainLoader(false)

      if (error) {
        this.errorMessage = ErrorMessageFromResponse(error, this.$t('planUpgrade.errorFetchingInvoice'))
        return
      }

      this.invoiceSummary = response.data
    },
    confirmPlanChange () {
      return { nextPage: this.nextPage }
    },
    async triggerFormSubmit (event) {
      this.$emit('SubmitForm')
      return false
    },
    async submitForm (event) {
      if (_.isEmpty(this.model.countryCode)) {
        this.errorMessage = this.$t('label.requiredCountry')
        return PageResponse(true)
      }

      if (this.showSelectState && _.isEmpty(this.model.state)) {
        this.errorMessage = this.$t('label.requiredState')
        return PageResponse(true)
      }

      return PageResponse(false, this.nextPage, {
        countryCode: this.model.countryCode,
        countryName: this.model.countryName.trim(),
        state: this.model.state
      })
    }
  },
  mounted () {}
}
